<template>
    <div>
        <form v-if="!response" @submit.prevent="onSubmit">
            <slot></slot>

            <button type="submit" :class="{ 'button_loading': loading }" :disabled="loading">{{ sendText }}</button>
        </form>
        <div v-else v-html="response"></div>
    </div>
</template>
<script>
import { api } from '@bit/duncank.work.api';

export default {
    name: 'Form',
    props: {
        sendText: {
            type: String,
            default: 'Versturen',
        },
        sendError: {
            type: String,
            default: 'Er ging iets mis met verzenden',
        },
        inputs: Object,
        formname: String,
    },
    data() {
        return {
            response: '',
            loading: false,
        };
    },
    methods: {
        onSubmit() {
            this.loading = true;
            this.inputs.formname = this.formname;
            this.inputs.lang = this.$store.getters['Language/current'];
            api.post({
                name: `send_${this.formname}`,
                endpoint: 'form/',
                data: this.inputs,
            }).then((r) => {
                if (r.data.results.response) {
                    this.response = r.data.results.response;
                }
            }).catch((err) => {
                console.log(err);
                this.$toast({ msg: this.sendError, classes: 'bg-danger' });
            }).then(() => {
                this.loading = false;
            });
        },
    },
};
</script>
